"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WizardComponent = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _get2 = _interopRequireDefault(require("lodash/get"));

require("./wizard.scss");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _reactRedux = require("react-redux");

var _StepIndicator = _interopRequireDefault(require("./StepIndicator"));

var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));

var _Grid = _interopRequireDefault(require("angieslist-react-components/lib/Grid"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _analytics = require("../../common/analytics");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var WizardComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(WizardComponent, _React$Component);

  var _super = _createSuper(WizardComponent);

  function WizardComponent(props) {
    var _this;

    (0, _classCallCheck2.default)(this, WizardComponent);
    _this = _super.call(this, props);
    _this.handleSubmit = _this.handleSubmit.bind((0, _assertThisInitialized2.default)(_this)); // If step is specified in the URL, set the state accordingly

    _this.state = {
      currentStep: parseInt((0, _get2.default)(props, 'router.location.query.step', '1'), 10)
    };
    return _this;
  }

  (0, _createClass2.default)(WizardComponent, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // Ensure we update state when query params change (e.g. the back button is pressed)
      this.state = {
        currentStep: parseInt((0, _get2.default)(nextProps, 'router.location.query.step', '1'), 10)
      };
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var currentStep = this.state.currentStep; // Official way to submit a redux-form from a parent component.
      // See http://redux-form.com/5.3.1/#/examples/submit-from-parent

      var form = (0, _get2.default)(this, "refs.childForm".concat(currentStep));

      if (typeof form.submit === 'function') {
        form.submit();
      } else {
        form.getWrappedInstance().submit();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          captions = _this$props.captions,
          children = _this$props.children,
          router = _this$props.router,
          nextButtonContent = _this$props.nextButtonContent,
          backButtonContent = _this$props.backButtonContent,
          submitButtonContent = _this$props.submitButtonContent,
          onFinalSubmit = _this$props.onFinalSubmit,
          headers = _this$props.headers,
          footers = _this$props.footers,
          id = _this$props.id,
          doneIcon = _this$props.doneIcon,
          form = _this$props.form,
          customButton = _this$props.customButton;

      var childrenArray = _react.default.Children.toArray(children);

      var currentStep = this.state.currentStep;

      var totalSteps = _react.default.Children.count(children);

      var formSubmitting = !!(0, _find2.default)(form, function (f) {
        return f.submitting;
      }); // Function to be called when the back button is pressed

      var onPrevious = function onPrevious() {
        if (currentStep <= 1) {
          window.location.href = '/';
        } else {
          router.push({
            pathname: router.location.pathname,
            query: {
              step: currentStep - 1
            }
          });
        }
      }; // Function to be called when the next button is pressed


      var onNext = function onNext() {
        router.push({
          pathname: router.location.pathname,
          query: {
            step: currentStep + 1
          }
        });
      };

      return /*#__PURE__*/(0, _jsx2.default)("div", {}, void 0, /*#__PURE__*/(0, _jsx2.default)(_Grid.default, {}, void 0, headers && headers[currentStep - 1] ? /*#__PURE__*/(0, _jsx2.default)(_Row.default, {
        className: "header-row"
      }, void 0, headers[currentStep - 1]) : null), /*#__PURE__*/(0, _jsx2.default)(_Grid.default, {
        className: "wizard-container ".concat(totalSteps === 1 ? 'one-step-form' : '')
      }, void 0, /*#__PURE__*/(0, _jsx2.default)(_Row.default, {}, void 0, totalSteps > 1 ? /*#__PURE__*/(0, _jsx2.default)(_StepIndicator.default, {
        totalSteps: totalSteps,
        captions: captions,
        currentStep: currentStep,
        doneIcon: doneIcon
      }) : null, /*#__PURE__*/_react.default.cloneElement(childrenArray[currentStep - 1], {
        ref: "childForm".concat(currentStep),
        // If it's the last page, call finalSubmit instead of onNext
        onSubmitSuccess: function onSubmitSuccess() {
          return currentStep < totalSteps ? onNext.apply(void 0, arguments) : onFinalSubmit.apply(void 0, arguments);
        }
      })), /*#__PURE__*/(0, _jsx2.default)(_Row.default, {
        className: "button-row"
      }, void 0, /*#__PURE__*/(0, _jsx2.default)(_Col.default, {}, void 0, /*#__PURE__*/(0, _jsx2.default)(_Col.default, {
        className: "pull-right"
      }, void 0, /*#__PURE__*/(0, _jsx2.default)(_analytics.Track, {}, void 0, /*#__PURE__*/(0, _jsx2.default)(_Button.default, {
        bsStyle: customButton || 'primary',
        bsSize: "small",
        id: "".concat(id, "--step-").concat(currentStep, "--next-button"),
        onClick: this.handleSubmit,
        flat: true,
        loading: formSubmitting,
        type: "submit"
      }, void 0, currentStep === totalSteps ? submitButtonContent : nextButtonContent))), /*#__PURE__*/(0, _jsx2.default)(_analytics.Track, {}, void 0, /*#__PURE__*/(0, _jsx2.default)("a", {
        className: "back-button btn btn-link",
        id: "".concat(id, "--step-").concat(currentStep, "--back-button"),
        onClick: onPrevious,
        onMouseDown: function onMouseDown(event) {
          onPrevious();
          event.stopPropagation();
        }
      }, void 0, backButtonContent)))), footers && footers[currentStep - 1] ? /*#__PURE__*/(0, _jsx2.default)(_Row.default, {
        className: "footer-row"
      }, void 0, footers[currentStep - 1]) : null));
    }
  }]);
  return WizardComponent;
}(_react.default.Component);

exports.WizardComponent = WizardComponent;
WizardComponent.defaultProps = {
  submitButtonContent: /*#__PURE__*/(0, _jsx2.default)("span", {}, void 0, "Submit"),
  nextButtonContent: /*#__PURE__*/(0, _jsx2.default)("span", {}, void 0, "Next"),
  backButtonContent: /*#__PURE__*/(0, _jsx2.default)("span", {}, void 0, /*#__PURE__*/(0, _jsx2.default)("i", {
    className: "icon icon-left-open"
  }), " Back")
};

var _default = (0, _compose.default)((0, _reactRedux.connect)(function (state) {
  return {
    form: state.form
  };
}), _pure.default)(WizardComponent);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/wizard/WizardComponent.js
// module id = 5142
// module chunks = 25